import { useState } from 'react';
import { BottomSheet } from './BottomSheet';
import { Save } from 'lucide-react';

const TEXT_POSITIONS = [
  { value: '0', label: 'Сверху' },
  { value: '1', label: 'Справа' },
  { value: '2', label: 'Снизу' },
  { value: '3', label: 'Слева' },
  { value: '4', label: 'Не отображать' },
];

const POLE_TYPES = [
  { value: 22, label: '-' },
  { value: 2, label: 'СГКФ улица' },
  { value: 15, label: 'СГКФ двор' },
  { value: 16, label: 'СГКФ магистраль' },
  { value: 3, label: 'СКФ улица' },
  { value: 17, label: 'СКФ двор' },
  { value: 18, label: 'СКФ магистраль' },
  { value: 19, label: 'Сварная улица' },
  { value: 20, label: 'Сварная двор' },
  { value: 21, label: 'Сварная магистраль' },
  { value: 4, label: 'Ж/б' },
  { value: 5, label: 'Деревянная' },
  { value: 14, label: 'Торшерная' },
];

const CABLE_BRANDS = [
  { value: 1, label: '-' },
  { value: 12, label: 'АВБбШв' },
  { value: 13, label: 'СИП' },
  { value: 14, label: 'АВВГ' },
  { value: 15, label: 'АПВ' },
  { value: 16, label: 'А' },
  { value: 142, label: 'АС' },
];

const CABLE_SECTIONS = [
  { value: 1, label: '-' },
  { value: 22, label: '4x10 мм²' },
  { value: 23, label: '4x16 мм²' },
  { value: 24, label: '4x25 мм²' },
  { value: 143, label: '95 мм²' },
  { value: 144, label: '70 мм²' },
  { value: 145, label: '50 мм²' },
  { value: 146, label: '35 мм²' },
];

const selectStyle = {
  width: '100%',
  padding: '12px 16px',
  fontSize: '15px',
  border: '1px solid #e5e5e5',
  borderRadius: '12px',
  background: '#f9f9f9',
  boxSizing: 'border-box',
  outline: 'none',
  appearance: 'none',
  WebkitAppearance: 'none',
};

const inputStyle = {
  width: '100%',
  padding: '12px 16px',
  fontSize: '15px',
  border: '1px solid #e5e5e5',
  borderRadius: '12px',
  background: '#f9f9f9',
  boxSizing: 'border-box',
  outline: 'none',
};

const labelStyle = {
  fontSize: '13px',
  color: '#888',
  display: 'block',
  marginBottom: '8px',
};

export function EditPoleSheet({
  title,
  initialNumber = '',
  initialLinkedtp = '',
  initialPoleType = 22,
  initialTextPosition = 0,
  initialCableBrand = 1,
  initialCableSection = 1,
  initialLengthBetweenPoles = 0,
  searchLink,
  onClose,
  onSave,
  onBack
}) {
  const [number, setNumber] = useState(initialNumber);
  const [linkedtp, setLinkedtp] = useState(initialLinkedtp);
  const [query, setQuery] = useState(initialLinkedtp || '');
  const [results, setResults] = useState([]);
  const [poleType, setPoleType] = useState(String(initialPoleType));
  const [position, setPosition] = useState(String(initialTextPosition));
  const [cableBrand, setCableBrand] = useState(String(initialCableBrand));
  const [cableSection, setCableSection] = useState(String(initialCableSection));
  const [length, setLength] = useState(String(initialLengthBetweenPoles));
  const [error, setError] = useState('');

  const handleSearch = async (text) => {
    setQuery(text);
    setLinkedtp('');
    if (text.length < 2) {
      setResults([]);
      return;
    }
    try {
      const response = await fetch(`${searchLink}${encodeURIComponent(text)}`);
      const data = await response.json();
      setResults(data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectLinkedtp = (obj) => {
    setLinkedtp(obj.name);
    setQuery(obj.name);
    setResults([]);
    setError('');
  };

  const handleSave = () => {
    if (!linkedtp) {
      setError('Не выбран питающий центр');
      return;
    }
    onSave({
      number,
      linkedtp,
      poleType: parseInt(poleType),
      textPosition: parseInt(position),
      cableBrand: parseInt(cableBrand),
      cableSection: parseInt(cableSection),
      lengthBetweenPoles: parseInt(length) || 0,
    });
  };

  return (
    <BottomSheet title={title} onClose={onClose} open={true} onBack={onBack} modal={true}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

        {/* Номер опоры */}
        <div>
          <label style={labelStyle}>Номер опоры</label>
          <input
            type="text"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            placeholder="Введите номер"
            style={inputStyle}
          />
        </div>

        {/* Питающий центр */}
        <div>
          <label style={labelStyle}>Питающий центр</label>
          <input
            type="text"
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Поиск..."
            style={inputStyle}
          />
          {results.length > 0 && (
            <div style={{
              marginTop: '4px',
              border: '1px solid #f0f0f0',
              borderRadius: '12px',
              overflow: 'hidden',
              maxHeight: '150px',
              overflowY: 'auto',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}>
              {results.map((obj, index) => (
                <div
                  key={obj.id}
                  onClick={() => handleSelectLinkedtp(obj)}
                  style={{
                    padding: '12px 16px',
                    fontSize: '14px',
                    color: '#1a1a1a',
                    borderBottom: index !== results.length - 1 ? '1px solid #f5f5f5' : 'none',
                    cursor: 'pointer',
                    background: 'white'
                  }}
                >
                  {obj.name}
                </div>
              ))}
            </div>
          )}
          {linkedtp && (
            <div style={{
              marginTop: '8px',
              padding: '10px 14px',
              background: '#eff6ff',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#3b82f6' }} />
              <span style={{ fontSize: '14px', color: '#1d4ed8', fontWeight: 500 }}>{linkedtp}</span>
            </div>
          )}
        </div>

        {/* Тип опоры */}
        <div>
          <label style={labelStyle}>Тип опоры</label>
          <select
            value={poleType}
            onChange={(e) => setPoleType(e.target.value)}
            style={selectStyle}
          >
            {POLE_TYPES.map(t => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>

        {/* Расположение номера */}
        <div>
          <label style={labelStyle}>Расположение номера</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            {TEXT_POSITIONS.map((pos) => (
              <button
                key={pos.value}
                onClick={() => setPosition(pos.value)}
                style={{
                  padding: '12px',
                  borderRadius: '12px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  background: position === pos.value ? '#3b82f6' : '#f5f5f5',
                  color: position === pos.value ? 'white' : '#1a1a1a',
                  transition: 'all 0.15s',
                  gridColumn: pos.value === '4' ? '1 / -1' : 'auto'
                }}
              >
                {pos.label}
              </button>
            ))}
          </div>
        </div>

        {/* Марка кабеля */}
        <div>
          <label style={labelStyle}>Марка кабеля</label>
          <select
            value={cableBrand}
            onChange={(e) => setCableBrand(e.target.value)}
            style={selectStyle}
          >
            {CABLE_BRANDS.map(b => (
              <option key={b.value} value={b.value}>{b.label}</option>
            ))}
          </select>
        </div>

        {/* Сечение кабеля */}
        <div>
          <label style={labelStyle}>Сечение кабеля</label>
          <select
            value={cableSection}
            onChange={(e) => setCableSection(e.target.value)}
            style={selectStyle}
          >
            {CABLE_SECTIONS.map(s => (
              <option key={s.value} value={s.value}>{s.label}</option>
            ))}
          </select>
        </div>

        {/* Длина между опорами */}
        <div>
          <label style={labelStyle}>Длина между опорами ср., м</label>
          <input
            type="number"
            value={length}
            onChange={(e) => setLength(e.target.value.replace(/[^0-9]/g, ''))}
            placeholder="0"
            style={inputStyle}
          />
        </div>

        {/* Сохранить */}
        <button
          onClick={handleSave}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '16px',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
            width: '100%'
          }}
        >
          <Save size={18} />
          Сохранить
        </button>

      </div>
    </BottomSheet>
  );
}